export default __webpack_public_path__ + "static/media/user.9ddb46ee.svg";